module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lCRr4"))).then(() => parcelRequire('ljYL6'));